
        import { MAIN_URL, REQUEST_URL } from "../../constant/ApplicationVariables";
        import { axiosInstance } from "../useAxios/useAxios";

        // const axiosInstance = axiosInstance;

        export const getReleaseFolderList_API = async (query) => {
            try {
                const response = await axiosInstance({
                    url: MAIN_URL.url + REQUEST_URL.folderStructureRelease + `?${query}`,
                    method: "GET",
                    // data: body,
                    contentType: "application/json"
                });
                console.log(response, "loginresponsne response");
                return response
            } catch (error) {
                console.log(error, "loginresponsne error");
                return error;
            }
        }


        export const getReleaseDetail_API = async (body) => {
            try {
                const response = await axiosInstance({
                    url: MAIN_URL.url + REQUEST_URL.releaseDetail,
                    method: "POST",
                    data: body,
                    contentType: "application/json"
                });
                console.log(response, "loginresponsne response");
                return response
            } catch (error) {
                console.log(error, "loginresponsne error");
                return error;
            }
        }


        export const addRelease_API = async (body) => {
            try {
                const response = await axiosInstance({
                    url: MAIN_URL.url + REQUEST_URL.release,
                    method: "POST",
                    data: body,
                    contentType: "application/json"
                });
                console.log(response, "loginresponsne response");
                return response
            } catch (error) {
                console.log(error, "loginresponsne error");
                return error;
            }
        }

        export const updateDeleteRelease_API = async (body) => {
            try {
                const response = await axiosInstance({
                    url: MAIN_URL.url + REQUEST_URL.release,
                    method: "PUT",
                    data: body,
                    contentType: "application/json"
                });
                console.log(response, "loginresponsne response");
                return response
            } catch (error) {
                console.log(error, "loginresponsne error");
                return error;
            }
        }


        export const getReleaseBacklogList_API = async (body) => {
            try {
                const response = await axiosInstance({
                    url: MAIN_URL.url + REQUEST_URL.releaseBacklog ,
                    method: "POST",
                    data: body,
                    contentType: "application/json"
                });
                console.log(response, "loginresponsne response");
                return response
            } catch (error) {
                console.log(error, "loginresponsne error");
                return error;
            }
        }



        export const getReleaseName_API = async (query) => {
            try {
                const response = await axiosInstance({
                    url: MAIN_URL.url + REQUEST_URL.releaseFetchName + `?${query}`,
                    method: "GET",
                    // data: body,
                    contentType: "application/json"
                });
                console.log(response, "loginresponsne response");
                return response
            } catch (error) {
                console.log(error, "loginresponsne error");
                return error;
            }
        }


        export const getSprintDetail_API = async (body) => {
            try {
                const response = await axiosInstance({
                    url: MAIN_URL.url + REQUEST_URL.sprintDetail ,
                    method: "POST",
                    data: body,
                    contentType: "application/json"
                });
                console.log(response, "loginresponsne response");
                return response
            } catch (error) {
                console.log(error, "loginresponsne error");
                return error;
            }
        }


        export const addSprint_API = async (body) => {
            try {
                const response = await axiosInstance({
                    url: MAIN_URL.url + REQUEST_URL.sprint,
                    method: "POST",
                    data: body,
                    contentType: "application/json"
                });
                console.log(response, "loginresponsne response");
                return response
            } catch (error) {
                console.log(error, "loginresponsne error");
                return error;
            }
        }


        export const updateDeleteSprint_API = async (body) => {
            try {
                const response = await axiosInstance({
                    url: MAIN_URL.url + REQUEST_URL.sprint,
                    method: "PUT",
                    data: body,
                    contentType: "application/json"
                });
                console.log(response, "loginresponsne response");
                return response
            } catch (error) {
                console.log(error, "loginresponsne error");
                return error;
            }
        }


        export const getSprintList_API = async (body) => {
            try {
                const response = await axiosInstance({
                    url: MAIN_URL.url + REQUEST_URL.sprintList ,
                    method: "POST",
                    data: body,
                    contentType: "application/json"
                });
                console.log(response, "loginresponsne response");
                return response
            } catch (error) {
                console.log(error, "loginresponsne error");
                return error;
            }
        }

        export const getSprintName_API = async (body) => {
            try {
                const response = await axiosInstance({
                    url: MAIN_URL.url + REQUEST_URL.sprintFetchName,
                    method: "POST",
                    data: body,
                    contentType: "application/json"
                });
                console.log(response, "loginresponsne response");
                return response
            } catch (error) {
                console.log(error, "loginresponsne error");
                return error;
            }
        }